'use client'

import { useState } from 'react'
import type { ClauseContentPG } from '@shared/db/schema/laws'
import Clause from '@/components/Law/Clause/Clause'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { Row } from '@christiankaindl/lyts'
import { theme } from '@/styles/theme.css'
import {
  Disclosure,
  DisclosureContent,
  DisclosureProvider,
} from '@ariakit/react'
import Text from '@shared/components/Text/Text'
import Button from '@shared/components/Button/Button'
import ClauseServer from '@/components/Law/Clause/Clause.server'

export function IntroText({
  clausePG,
  totalClauses,
  name = 'Vorwort/Präambel',
}: {
  clausePG: ClauseContentPG
  totalClauses: number
  name?: string
}) {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <DisclosureProvider defaultOpen={false} setOpen={setIsOpen}>
      <div>
        <Disclosure
          render={
            <Row
              xAlign='space-between'
              style={{ cursor: 'pointer', padding: '0px 0px 9px' }}
            />
          }
        >
          <Text weight={500}>{name}</Text>
          <Button circular square size='small'>
            {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </Button>
        </Disclosure>
        <DisclosureContent unmountOnHide>
          <Clause id='intro-text' index={0}>
            <ClauseServer
              clausePG={clausePG}
              totalClauses={totalClauses}
              renderTitle={false}
            />
          </Clause>
        </DisclosureContent>
        {!isOpen && (
          <hr
            style={{
              borderBottom: `1.5px dashed ${theme.colors.borders.border1}`,
              height: 0,
              opacity: 1,
              backgroundColor: 'transparent',
              marginBottom: '-1em',
              marginTop: '0.25em',
            }}
          />
        )}
      </div>
    </DisclosureProvider>
  )
}
